import React, { Component } from "react";

class IconEmail extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <svg x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" role="presentation">
                <path
                    d="M3.8,10.5v29.1h42.5V10.5H3.8z M19.7,27.8l5.3,2.9l5.3-2.9L42,37.3H8L19.7,27.8z M6,36.1V20.2l11.7,6.5L6,36.1z M32.4,26.7
	        L44,20.2v15.9L32.4,26.7z M44,12.7v4.9L25,28.2L6,17.6v-4.9H44z"
                />
            </svg>
        );
    }
}

export default IconEmail;
